import { get } from '@core/api/baseApi';
import { ResultResponse } from '@core/types';
import { Patient } from '@core/types/Patient';

const getPatient = async (patientId: string): Promise<ResultResponse<Patient>> =>
  await get(`/UserPatient/${patientId}`);

export default getPatient;
